module.exports = __webpack_public_path__ + "images/surface-area-63dd5762e7b4d648d6e6c4fded0636b6.jpg";